import type { ProductVariantDetails, ProductVariantListResponse } from "../types/storefront-product.types";

export default class StorefrontProductService {
  private apigateway: string | null;
  private productId: string | null;
  private tenantId: string | null;
  private sku: string | null;
  private productVersionId: string | null;
  private token: string | null;
  // private ownerId: string | null;

  constructor(options: {
    apigateway: string | null;
    productId: string | null;
    token: string | null;
    tenantId: string | null;
    // userId: string | null,
    productVersionId: string | null;
    sku: string | null;
  }) {
    this.apigateway = options.apigateway;
    this.productId = options.productId;
    this.token = options.token;
    this.tenantId = options.tenantId;
    // this.ownerId = options.userId;
    this.sku = options.sku;
    this.productVersionId = options.productVersionId;
  }

  public async getVariantDesign(): Promise<ProductVariantListResponse> {
    const method = "GET";
    const url = new URL(String(this.apigateway));
    url.pathname = `/api/storefront/v1/products/${this.productId}/variant-designs`;
    url.searchParams.set("productVersionId", String(this.productVersionId));
    url.searchParams.set("sku", String(this.sku));
    url.searchParams.set("tenantId", String(this.tenantId));

    return await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      },
    })
      .then((res) => res.json())
      .catch(console.error);
  }

  public async getProductSummary(): Promise<ProductVariantDetails> {
    const method = "GET";
    const url = new URL(String(this.apigateway));
    url.pathname = `/api/storefront/v1/products/${this.productId}/summary`;
    url.searchParams.set("productVersionId", String(this.productVersionId));
    url.searchParams.set("sku", String(this.sku));
    url.searchParams.set("tenantId", String(this.tenantId));

    return await fetch(url.href, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.token}`,
      },
    })
      .then((res) => res.json())
      .catch(console.error);
  }
}
